import React from 'react';

import { View } from '@uncinc/react-drupal-core';

interface RentalLocationsOverviewProps {
  display: string;
}

const RentalLocationsOverview: React.FC<RentalLocationsOverviewProps> = ({ display }) => (
  <div className="RentalLocationsOverview">
    <View id="rental_locations" display={display} />
  </div>
);

export default RentalLocationsOverview;
